export const visit = (vm, at) => {
vm(require("foundations-components/lang/es-mx.lyaml"));
at({ "es-mx": { "placeholder": "marcador de posici\xF3n" } });
};